import styled from 'styled-components';

export const Container = styled.div`
  min-height: 220px;
  max-width: 500px;
  width: 97vw;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
`;

export const Header = styled.div`
  border-radius: 5px 5px 0;
  height: 53px;
  width: 100%;
  padding: 10px 20px;
  background-color: ${({ theme }) => theme.colors.primary};
  justify-content: space-between;
  flex-direction: row;
  display: flex;
`;

export const HeaderTitle = styled.p`
  font-family: ${({ theme }) => theme.fonts.primaryFont};
  color: ${({ theme }) => theme.colors.lighterText};
  font-size: 22px;
  font-weight: 500;
`;

export const Content = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  border-radius: 0px 0px 5px 5px;
  background-color: ${({ theme }) => theme.colors.background};
`;
